import type { ElementMenuItem } from '../context/elementContextMenuContext';
import { Link01Icon } from '@milanote/roma-icons';
import { ElementContextMenuPredicates } from './elementContextMenuPredicates';

const {
    areAllImages,
    canAddImage,
    canCopyBoardLink,
    canCopyLinkAddress,
    canDownloadOriginal,
    canReplaceImage,
    canToggleImageAspectRatio,
    isImageCroppedToGrid,
    isSingleFile,
    isSingleImage,
    isSinglePopulatedDrawing,
    isVideoSelection,
} = ElementContextMenuPredicates;

const replaceImage: ElementMenuItem<'replaceImage'> = {
    type: 'action',
    id: 'replaceImage',
    label: (context) =>
        context.translate(isVideoSelection(context) ? 'element.replacePreview' : 'element.replaceImage'),
    availabilityPredicate: canReplaceImage,
    onAction: (context) => context.actions.replaceImage(),
};
const addImage: ElementMenuItem<'replaceImage'> = {
    type: 'action',
    id: 'addImage',
    localeKey: 'element.addImage',
    availabilityPredicate: canAddImage,
    onAction: (context) => context.actions.replaceImage(),
};
const downloadOriginal: ElementMenuItem<'downloadOriginal'> = {
    type: 'action',
    id: 'downloadOriginal',
    label: (context) => {
        if (isSingleImage(context)) return context.translate('element.downloadOriginalImage');
        if (areAllImages(context)) return context.translate('element.downloadOriginalImages');
        return context.translate('element.download');
    },
    availabilityPredicate: canDownloadOriginal,
    onAction: (context) => context.actions.downloadOriginal(),
};
const imageAspectRatio: ElementMenuItem<'toggleImageAspectRatio'> = {
    type: 'action',
    id: 'imageAspectRatio',
    localeKey: 'element.cropImageToFitDotGrid',
    availabilityPredicate: canToggleImageAspectRatio,
    selectedPredicate: isImageCroppedToGrid,
    onAction: (context) => context.actions.toggleImageAspectRatio(),
};
const openFile: ElementMenuItem<'copyLinkToFile'> = {
    type: 'action',
    id: 'openFile',
    label: (context) =>
        context.translate(context.clipboardInsertSupported ? 'element.copyLinkToFile' : 'element.openFile'),
    availabilityPredicate: isSingleFile,
    onAction: (context) => context.actions.copyLinkToFile(),
};
const copyLink: ElementMenuItem<'copyLinkAddress'> = {
    type: 'action',
    id: 'copyLink',
    icon: Link01Icon,
    localeKey: 'element.copyLinkAddress',
    availabilityPredicate: canCopyLinkAddress,
    onAction: (context) => void Promise.resolve(context.actions.copyLinkAddress()).catch(() => {}),
};
const copyBoardLink: ElementMenuItem<'copyBoardLink'> = {
    type: 'action',
    id: 'copyBoardLink',
    icon: Link01Icon,
    localeKey: 'element.copyBoardLink',
    availabilityPredicate: canCopyBoardLink,
    onAction: (context) => void Promise.resolve(context.actions.copyBoardLink()).catch(() => {}),
};
const downloadSvg: ElementMenuItem<'downloadSvg'> = {
    type: 'action',
    id: 'downloadSvg',
    localeKey: 'element.downloadSvg',
    availabilityPredicate: isSinglePopulatedDrawing,
    onAction: (context) => context.actions.downloadSvg(),
};

export const ELEMENT_MEDIA_CONTEXT_MENU_ITEMS = {
    replaceImage,
    addImage,
    downloadOriginal,
    imageAspectRatio,
    openFile,
    copyLink,
    copyBoardLink,
    downloadSvg,
};
